import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);